import { render, staticRenderFns } from "./EditVTPage.vue?vue&type=template&id=346fbe68&"
import script from "./EditVTPage.vue?vue&type=script&lang=js&"
export * from "./EditVTPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports